import * as yup from 'yup';
import { gql } from '@apollo/client';
import { throttle } from 'lodash';
import { clientNoAuth } from './clientNoAuth';

const responseDataSchema = yup.object().shape({
    data: yup.object().shape({
        refreshToken: yup.object().shape({
            token: yup.string().required(),
            refresh_token: yup.string().required(),
        }),
    }),
});

type RefreshTokenResponse = {
    token: string;
    refresh_token: string;
};

export const fetchRefreshTokenGraphQL = throttle(async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const response = await clientNoAuth.mutate({
        mutation: gql(
            'mutation RefreshToken($refreshToken: String!) {refreshToken(refreshToken: $refreshToken) { token, refresh_token}}',
        ),
        variables: { refreshToken },
        context: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    });

    const validResponse = await responseDataSchema.validate(response);

    return validResponse.data.refreshToken;
}, 2000);
